import { AxiosResponse } from 'axios';
import { axiosRequest } from 'core/axios';
import { getHeaders } from '../../core/common-methods';
import { LegalDocument } from 'core/legalDocuments/models';
import { PageDTO } from 'core/utils/BasicModels';
import { createRequestAction, RequestAction } from 'core/utils/actionUtils';
import { Dispatch } from 'redux';

export const GET_ALL_LEGAL_DOCUMENTS: RequestAction = createRequestAction('GET_ALL_LEGAL_DOCUMENTS');

const getLocationQueryParam = (countryCode: string) => {
  if (countryCode) {
    return `?location=${countryCode}`
  }
  return '';
}

const mapV2Doc = (legalDoc: any) => ({
  ...legalDoc,
  filepath: legalDoc.file_path,
  typeRow: legalDoc.type,
  app: legalDoc.app_id,
  startDate: legalDoc.start_date,
  endDate: legalDoc.end_date
})

const baseURL = process.env.API_URL;

export const getAllLegalDocuments = (countryCode: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: GET_ALL_LEGAL_DOCUMENTS.REQUEST });
    const endpoint = `v2/legal-docs/all?location=${countryCode}`;
    const basicAuth = process.env.REACT_APP_LICENSING_BASIC_AUTH;
    let legalDocuments: any = await axiosRequest.get<any, AxiosResponse<PageDTO<LegalDocument[]>>>(
      endpoint,
      {
        baseURL,
        headers: {
          Authorization: `Basic ${basicAuth}`, // Basic auth to get all legal docs even though user is not authenticated
        }
      }
    );
    legalDocuments = legalDocuments.data.content.map(mapV2Doc);
    dispatch({ type: GET_ALL_LEGAL_DOCUMENTS.SUCCESS, payload: legalDocuments });
    return legalDocuments;
  } catch (e) {
    dispatch({ type: GET_ALL_LEGAL_DOCUMENTS.ERROR, payload: e });
    throw e;
  }
};

export const fetchUnsignedLegalDocuments = async (countryCode: string) => {
  let legalDocumentsToSign: string[] = [];
  try {
    const endpoint = `/v2/legal-docs/unsigned${getLocationQueryParam(countryCode)}`;
    const response = await axiosRequest.get<any, AxiosResponse<any>>(
      endpoint,
      {
        headers: getHeaders().common,
        baseURL
      }
    );
    if (response.status === 200) {
      legalDocumentsToSign = response.data.legal_docs;
    }
    return legalDocumentsToSign;
  } catch (e) {
    console.error(e);
    return legalDocumentsToSign;
  }
}
